var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"text-right"},[(!_vm.loading)?_vm._t("default"):_c('v-skeleton-loader',{staticClass:"mx-2",attrs:{"max-width":_vm.width,"type":"text"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }